import React, { JSX } from 'react';
import {
    List,
    TextField,
    TopToolbar,
    CreateButton,
    Datagrid,
    EditButton,
    BooleanField,
    FilterButton
} from 'react-admin';


const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            {/* No gate here on purpose: react-admin asks `authProvider.canAccess` for this button
                itself, and the map there names the verb. A check beside it would be the same
                rule written twice. */}
                <CreateButton />
            {/*<FilterButton />*/}
        </TopToolbar>
    );
}


export const SubscriptionList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ <ListActions/> }

        >
            <Datagrid bulkActionButtons={ false } >
                <TextField source="id" />
                <TextField source="name"  />
                <BooleanField source="active" />
                <BooleanField source="liveMode" />
                {/*<SelectField source="status" choices={ selectChoices } />*/}
                <EditButton />

            </Datagrid>
        </List>
    );
}
